import Joi from 'joi';

export class MicroFrontendService {
  public static validateUrl = (url: any): boolean => {
    const URL_SCHEMA_VALIDATION = Joi.string()
      .trim()
      .uri({ scheme: ['http', 'https'] })
      .required();

    try {
      Joi.attempt(url, URL_SCHEMA_VALIDATION);
    } catch (error) {
      return false;
    }

    return true;
  };
}
